module.exports = __webpack_public_path__ + "media/images/competitions/clipboard-27340af730225fb9db368738c95cf389.png";